export default __webpack_public_path__ + "static/media/tasksIcon.2bcb22e5.svg";